import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings} from '../../../core';
import { Observable } from 'rxjs';
import { EQueryStageReadModel } from '../models/e-query-stage';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';

@Injectable()
export class EQueryStageStorage {
    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) {
    }
    public getEQueryStage(eQueryStageId: number): Observable<EQueryStageReadModel> {
        return this.http.get(
            `${this.settings.apiUrl}/e-query-stages/${encodeURI(eQueryStageId.toString())}`
        ).pipe(
            map((r) => deserialize(r, EQueryStageReadModel))
        );
    }
}
